import { useMemo } from 'react';

import type { ShareActionsOptions, ShareChannel } from 'src/app/shared/hooks/share';

import type { ShareablePost } from '../index';

import { useGetDashboardShareContent } from './useGetDashboardShareContent';
import { useGetDashboardShareTrackingData } from './useGetDashboardShareTrackingData';
import { useGetDashboardShareUrl } from './useGetPetitionShareUrl';
import { useOnDashboardShareSuccess } from './useOnDashboardShareSuccess';

export function useDashboardShareOptions(
	previewLinkConfigs?: readonly ShareablePost[],
	customTrackingData?: Array<Record<string, string>>,
	customUtmParams?: Array<Record<string, string>>,
): ShareActionsOptions<ShareChannel> {
	const getUrl = useGetDashboardShareUrl(previewLinkConfigs, customUtmParams);
	const getContent = useGetDashboardShareContent();
	const getTrackingData = useGetDashboardShareTrackingData(customTrackingData);
	const onSuccess = useOnDashboardShareSuccess();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getUrl,
			getContent,
			getTrackingData,
			onSuccess,
		}),
		[getUrl, getContent, getTrackingData, onSuccess],
	);
}
